import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/pet/og.png';
import type { BasePageConfig } from '../../../BasePageConfig';

export type Config = BasePageConfig;
export const config: Config = {
  seo: {
    title: 'Dog Insurance by Lemonade',
    metaTitle: 'Dog Insurance by Lemonade',
    description: 'Pet Insurance Tailored for Your Dog Protection just right for your pet (and your pocket)',
    ogImage: ogImage.src,
    uniqueCanonicalUrl: 'https://www.lemonade.com/pet/dogs',
  },
  layout: { ...sharedConfig['en-US'].layout },
};
